const AboutUs = () => {
  return (
    <div className="bg-gray-50 text-gray-800">
       <section className="relative bg-gradient-to-r from-black via-gray-900 to-yellow-600 text-white py-24 px-6 text-center overflow-hidden">
        <div className="relative z-10 max-w-4xl mx-auto">
           <h1 className="text-4xl md:text-6xl font-extrabold mb-4 transition-all duration-700">
            About <span className="text-primary">Express Tire Works</span>
          </h1>
           <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-200">
            Your one-stop shop for premium tires, wheels, and professional
            installations — all designed to make your drive safer and smoother.
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <img
            src="../images/header-banner.jpg"
            alt="Tire Shop"
            className="rounded-2xl shadow-lg hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div>
          <h2 className="text-3xl font-bold mb-4 text-gray-900">
            Driven by Quality. Focused on You.
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            At <span className="font-semibold">Express Tire Works</span>, we
            believe getting new tires or wheels should be simple, transparent,
            and stress-free. That’s why we’ve built a system that allows you to
            browse, book, and even order your preferred tires or wheels online.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Once your order is ready at our in-house store, you can schedule an
            appointment for expert fitting — quick, professional, and done right
            the first time.
          </p>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-900">
            Why Choose Express Tire Works?
          </h2>

          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8">
            {/* Premium Brands */}
            <div className="p-6 bg-gray-100 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <svg
                className="w-12 h-12 text-primary mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 19a2 2 0 01-2-2V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H6z"
                />
              </svg>
              <h3 className="text-xl font-semibold mb-2">Premium Brands</h3>
              <p className="text-gray-600 text-sm">
                Explore a wide range of top tire and wheel brands and models to
                fit your vehicle perfectly.
              </p>
            </div>

            {/* Expert Installation */}
            <div className="p-6 bg-gray-100 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <svg
                className="w-12 h-12 text-primary mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 19l9-5-9-5-9 5 9 5z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 12l9-5-9-5-9 5 9 5z"
                />
              </svg>
              <h3 className="text-xl font-semibold mb-2">Expert Installation</h3>
              <p className="text-gray-600 text-sm">
                Our in-house professionals ensure a hassle-free, precise, and
                safe tire fitting experience.
              </p>
            </div>

            {/* Transparent Pricing */}
            <div className="p-6 bg-gray-100 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <svg
                className="w-12 h-12 text-primary mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8c-1.657 0-3 1.343-3 3 0 1.11.606 2.078 1.5 2.6v1.4h3v-1.4A2.993 2.993 0 0015 11c0-1.657-1.343-3-3-3z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 1v4m0 14v4M5 12H1m22 0h-4"
                />
              </svg>
              <h3 className="text-xl font-semibold mb-2">Transparent Pricing</h3>
              <p className="text-gray-600 text-sm">
                Get the right price every time — no hidden fees, no surprises,
                just honest value.
              </p>
            </div>

            {/* Customer First */}
            <div className="p-6 bg-gray-100 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <svg
                className="w-12 h-12 text-primary mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="7" r="4" />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"
                />
              </svg>
              <h3 className="text-xl font-semibold mb-2">Customer First</h3>
              <p className="text-gray-600 text-sm">
                From online booking to in-store fitting, we make sure your
                experience is smooth and satisfying.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-primary py-16 text-center text-white">
        <h2 className="text-3xl font-bold mb-4">
          Ready for a Hassle-Free Tire Experience?
        </h2>
        <p className="text-lg mb-6">
          Book your appointment today and enjoy seamless service from start to finish.
        </p>
        <button className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-yellow-100 transition-all">
          Book Appointment
        </button>
      </section>
    </div>
  );
};

export default AboutUs;
